/********************************************
 * Dependencies from other libs and components
 *******************************************/

// === General Libraries & Functions
//
//  import ReactDOM from 'react-dom';
//  import update from 'immutability-helper';
//
import React, { Component } from 'react';
import PropTypes from 'prop-types';


// === Local Libraries & Functions
//
//  import { wrapStore } from '../../utils/reducerUtils';
//  import { initStore } from './store';
//
import { wrapStore } from '../../utils/reducerUtils';
import { initStore } from './store';

import Form from './Form';
import Result from './Result';




/********************************************
 * Main Component
 *******************************************/

class AQLCalculator extends Component {

  // static defaultProps = {
  //
  // };
  //
  // static propTypes = {
  //
  // };

  constructor({  }) {
    super();

    this.state = {
    };
  }

  render() {
    const {  } = this.props;
    const {  } = this.state;

    return (
      <div className={'aql-calculator'}>
        <Form/>
        <Result/>
      </div>
    );
  }
}

export default wrapStore(AQLCalculator, initStore, {
  //loadDocuments: actions.loadDocuments,
});
